export const defaultActionTypeList = [
  { title: 'b1c94ca2fb', value: '', isActive: true },
  { title: 'b127158518', value: 'ASSIGNED', isActive: false },
  { title: 'e69dc6d738', value: 'REVOKED', isActive: false },
  { title: 'b1b0643f87', value: 'SUSPENDED', isActive: false },
  { title: 'd94ddaf859', value: 'RESUMED', isActive: false },
  { title: 'a21ebb0670', value: 'ADDED', isActive: false },
  { title: '6b22e7bd99', value: 'BOUND', isActive: false },
  { title: 'bc0b0216f0', value: 'UNBOUND', isActive: false },
  { title: '84e559479b', value: 'Terminated', isActive: false },
  { title: '224d957605', value: 'ACTIVATED', isActive: false },
  { title: '24fe48030f', value: 'EXPIRED', isActive: false },
  { title: '6232e6f5f6', value: 'BULK IMPORT DEVICE', isActive: false },
  { title: '22f7cca17a', value: 'BULK IMPORT LICENSE', isActive: false },
  { title: 'ada806c830', value: 'BULK CONFIGURATION', isActive: false },
  { title: '96975195fc', value: 'COTERMINATED', isActive: false }
];

export const columnList = [
  { label: '3ec365dd53', accessor: 'time', sortable: true },
  { label: '3841f18e82', accessor: 'account', sortable: true },
  { label: '5d5c4ad5db', accessor: 'licenseKey', sortable: true },
  { label: '004bf6c9a4', accessor: 'action', sortable: true },
  { label: '8b129f7b5b', accessor: 'details', sortable: true }
];

export const defaultSearch = {
  fuzzy: null,
  account: null,
  actionType: null
}

export const searchType = {
  fuzzy: {
    value: 'fuzzy'
  },
  account: {
    value: 'account',
    label: '3841f18e82'
  },
  actionType: {
    value: 'actionType',
    label: '004bf6c9a4'
  }
};